<template>
	<!-- formulário -->
	<div>
		<div class="container-fluid conteudo" v-show="!loadTripulacaoTecnica">
			<div class="fl-cabecalho" v-if="isNotModal">
				<div class="row">
					<div class="col-lg-4 col-xs-12">
						<i class="icon icon-novo_cadastro"></i>
						<h3 v-if="tripulacaoTecnica == '1'">
							{{
								_traducao('global', 'cadastroTripulanteTecnico').toUpperCase()
							}}
						</h3>
						<h3 v-else>
							{{ _traducao('global', 'cadastroPassageiros').toUpperCase() }}
						</h3>
						<h4 @click="_exibeSub('ad')" style="cursor: pointer">
							{{ _traducao('menu', 'menuAdministracao').toUpperCase() }}
							{{ _traducao('menu', 'menuGeral').toUpperCase() }}
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</h4>
					</div>
					<div class="col-md-4 col-xs-12">
						<span>
							<i
								class="icon icon-sub"
								:class="[
									form.passageiro.id != 0
										? 'icon-editar'
										: 'icon-solicitacao_nova_solicitacao'
								]"
							></i>
							<h3>
								{{
									form.passageiro.id != 0
										? _traducao('global', 'editar')
										: _traducao('global', 'novo')
								}}
							</h3>
						</span>
						<h4 v-if="tripulacaoTecnica == '1'">
							{{ _traducao('global', 'tripulanteTecnico') }}
						</h4>
						<h4 v-else>{{ _traducao('global', 'passageiro') }}</h4>
					</div>
					<div class="col-lg-4 col-xs-12">
						<button
							@click="voltaLista"
							:title="_traducao('global', 'voltar')"
							class="btn btn-default pull-right btn-lg"
						>
							<i
								class="icon-left"
								style="font-size: 18px"
								aria-hidden="true"
							></i>
						</button>
					</div>
				</div>
			</div>
			<div class="row form-group">
				<div class="col-xs-12">
					<flCabecalhoForm :texto="_traducao('global', 'dadosIniciais')" />
					<!-- NOME -->
					<div
						class="col-sm-3 form-group"
						:class="{'has-error': erro.nome != ''}"
					>
						<label>* {{ _traducao('global', 'nome') }}: </label>
						<input
							v-model="form.passageiro.nome"
							class="form-control input-sm"
							:disabled="form.passageiro.bloquear || desabilitarCampoApi()"
						/>
						<p class="help-block" v-show="erro.nome != ''">{{ erro.nome }}</p>
					</div>
					<!-- DATA DE NASCIMENTO -->
					<div class="col-sm-3 form-group">
						<label>{{ _traducao('global', 'dataNascimento') }}:</label>
						<flDateTime
							@v-model="(val) => (form.passageiro.data_nascimento = val)"
							:value="form.passageiro.data_nascimento"
							name="dataNascimento"
							:lang="_getLangDp"
							:format="_formatDate"
							:disabled="desabilitarCampoApi()"
						/>
					</div>
					<!--PORTE PASSAGEIRO-->
					<div
						class="col-sm-3 form-group"
						:class="{'has-error': erro.sexo != ''}"
					>
						<label v-if="tripulacaoTecnica == '1'"
							>* {{ _traducao('global', 'porteTripulante') }}:
							<i
								class="fa fa-fw fa-info-circle"
								v-tooltip="
									'É obrigatório o campo de sexo para definição do peso médio do Tripulante de acordo com o regulamento da ANAC.'
								"
							></i
						></label>
						<label v-else
							>* {{ _traducao('global', 'portePassageiro') }}:
							<i
								class="fa fa-fw fa-info-circle"
								v-tooltip="
									'É obrigatório o campo de porte para definição do peso médio do passageiro de acordo com o regulamento da ANAC.'
								"
							></i
						></label>
						<select
							v-model="form.passageiro.sexo"
							class="form-control input-sm"
							:disabled="desabilitarCampoApi()"
						>
							<option value>
								{{ _traducao('global', 'escolha').toUpperCase() }}
							</option>
							<option value="m">{{ _traducao('global', 'masc') }}</option>
							<option value="f">{{ _traducao('global', 'fem') }}</option>
							<option value="c">{{ _traducao('global', 'crianca') }}</option>
						</select>
						<p class="help-block" v-show="erro.sexo != ''">{{ erro.sexo }}</p>
					</div>
					<!-- NACIONALIDADE -->
					<div class="col-sm-3 form-group">
						<label>{{ _traducao('global', 'nacionalidade') }}: </label>
						<input
							v-model="form.passageiro.nacionalidade"
							class="form-control input-sm"
						/>
					</div>
					<!-- DOCUMENTOS OBRIGATÓRIOS -->
					<!-- CPF -->
					<div
						class="col-sm-3 form-group"
						:class="{
							'has-error': erro.cpf != '',
							'col-sm-3 form-group': exibeOutro
						}"
					>
						<label
							><span v-show="documentoObrigatorio == 'cpf'">*</span>
							{{ _traducao('menuAGnovoUsuario', 'menuAGcpf') }}:</label
						>
						<input
							type="text"
							v-model="form.passageiro.cpf"
							v-mask="_vdocumento"
							class="form-control input-sm"
							@blur="validarCPF"
							:disabled="desabilitarCampoApi()"
						/>
						<p class="help-block" v-show="erro.cpf != ''">
							{{ erro.cpf }}
						</p>
					</div>
					<!-- RG -->
					<input-text
						class="col-sm-3 form-group"
						:class="{
							'col-sm-3 form-group': exibeOutro
						}"
						label="RG"
						v-model="form.passageiro.rg"
						:mensagem-erro="erro.rg"
						:obrigatorio="documentoObrigatorio == 'rg'"
						:disabled="desabilitarCampoApi()"
					/>
					<!-- MATRÍCULA -->
					<input-text
						class="col-sm-3 form-group"
						:class="{
							'col-xs-6 col-sm-4 col-md-4 col-lg-2 form-group': exibeOutro
						}"
						:label="_traducao('global', 'matricula')"
						v-model="form.passageiro.matricula"
						:mensagem-erro="erro.matricula"
						:obrigatorio="documentoObrigatorio == 'matricula'"
						:disabled="desabilitarCampoApi()"
					/>
					<!-- PASSAPORTE -->
					<input-text
						class="col-sm-3 form-group"
						:class="{
							'col-sm-3 form-group': exibeOutro
						}"
						:label="_traducao('global', 'passaporte')"
						v-model="form.passageiro.passaporte"
						:mensagem-erro="erro.passaporte"
						:obrigatorio="documentoObrigatorio == 'passaporte'"
					/>
					<!-- OUTRO -->
					<input-text
						class="col-sm-3 form-group"
						:label="nomeOutroDocumento"
						v-model="form.passageiro.outro"
						:mensagem-erro="erro.outro"
						:obrigatorio="documentoObrigatorio == 'outro'"
						v-if="exibeOutro"
					/>
					<!-- PESO -->
					<div class="col-sm-3 form-group">
						<label
							>* {{ _traducao('global', 'pesoMedio') }}:
							<i
								class="fa fa-fw fa-info-circle"
								v-tooltip="
									'O campo de peso médio é baseado nos regulamentos vigentes. Homem 80 kg (176 lb), Mulher adulta 70 kg (154 lb), Criança entre (2 e 12 anos) 30 kg (66 lb).'
								"
							></i>
						</label>
						<money
							disabled
							v-model="form.passageiro.pesoMedio"
							v-bind="_vpercem(2)"
							class="form-control input-sm"
							:disabled="desabilitarCampoApi()"
						></money>
					</div>
					<div
						class="col-sm-3 form-group"
						:class="{'has-error': erro.peso != ''}"
					>
						<label>* {{ _traducao('global', 'pesoReal') }}: </label>
						<money
							v-model="form.passageiro.peso"
							v-bind="_vpercem(2)"
							class="form-control input-sm"
							:disabled="desabilitarCampoApi()"
						></money>
						<p class="help-block" v-show="erro.peso != ''">{{ erro.peso }}</p>
					</div>
					<!-- TELEFONE -->
					<div
						class="col-sm-3 form-group"
						:class="{'has-error': erro.telefone != ''}"
					>
						<label>{{ _traducao('global', 'telefone') }}: </label>
						<input
							v-model="form.passageiro.telefone"
							class="form-control input-sm"
							v-if="desabilitarCampoApi()"
							:disabled="form.passageiro.bloquear || desabilitarCampoApi()"
						/>
						<input
							v-else
							v-model="form.passageiro.telefone"
							class="form-control input-sm"
							v-mask="_vtelefone"
							:disabled="form.passageiro.bloquear || desabilitarCampoApi()"
						/>
					</div>
					<!-- É ESTRANGEIRO ? -->
					<div class="col-sm-3 form-group">
						<label> {{ _traducao('global', 'eEstrangeiro') }}? </label>
						<br />
						<div class="btn-group print-button-group" role="group">
							<flSimNao
								v-model="form.passageiro.estrangeiro"
								@change="verificaObrigatorio"
							/>
						</div>
					</div>
					<!-- ATENÇÃO ESPECIAL -->
					<div class="col-xs-12 col-sm-6 col-md-3 col-lg-3 no-print form-group">
						<label>{{ _traducao('global', 'atencaoEspecial') }}: </label>
						<div class="input-group">
							<select class="input-sm form-control" v-model="atencaoEspecial">
								<option value="">
									{{ _traducao('global', 'escolha').toUpperCase() }}
								</option>
								<option
									:value="atencao_especial"
									v-for="atencao_especial in listaAtencaoEspecial"
									:key="'atencao-especial-' + atencao_especial.id"
								>
									{{ atencao_especial.descricao }}
								</option>
							</select>
							<span class="input-group-btn">
								<button
									class="btn btn-sm btn-info"
									type="button"
									@click="clickAddAtencao"
								>
									ADD<i class="fa fa-arrow-right fa-fw"></i>
								</button>
							</span>
						</div>
						<div class="row">
							<div
								class="col-xs-12 col-sm-6 col-md-9 col-lg-9"
								:class="{'form-group': _isMobile}"
							>
								<label style="margin-bottom: 6px">&nbsp;</label>
								<br />
								<span
									v-for="att in atencaoNaoExcluido"
									:key="'att-' + att.id"
									style="margin-top: 3px"
								>
									<span
										title="Clique para remover"
										@click="clickExcluirAtencao(att)"
										class="label-click"
									>
										{{ att.descricao }}
										<i class="fa fa-times no-print"></i>
									</span>
								</span>
							</div>
						</div>
					</div>
					<div class="col-sm-3 form-group" v-if="tipoPassageiro">
						<label> {{ _traducao('global', 'tipoPassageiro') }}? </label>
							<div>
								<div
									class="btn-group"
									data-toggle="buttons"
									style="width: 60%"
								>
									<button
										class="btn"
										style="width: calc(100% / 2)"
										:class="{'btn-primary': form.passageiro.tipo_passageiro == 1}"
										@click="form.passageiro.tipo_passageiro = 1"
									>
										<small>{{ _traducao('global', 'interno') }}</small>
									</button>
									<button
										class="btn"
										style="width: calc(100% / 2)"
										:class="{'btn-primary': form.passageiro.tipo_passageiro == 2}"
										@click="form.passageiro.tipo_passageiro = 2"
									>
										<small>{{ _traducao('global', 'externo') }}</small>
									</button>
								</div>
							</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<flCabecalhoForm :texto="_traducao('global', 'dadosFuncionais')" />
					<!-- ORGÃO APOIADO -->
					<div class="col-xs-12 col-sm-4 col-md-4 col-lg-3 form-group">
						<label
							>{{ centrodeCusto }} / {{ _traducao('global', 'empresa') }}:
						</label>
						<select
							v-model="form.passageiro.id_orgao_apoiado"
							:disabled="usuarioSolicitante || desabilitarCampoApi()"
							class="form-control input-sm"
						>
							<option value="">
								{{ _traducao('global', 'escolha').toUpperCase() }}
							</option>
							<option
								v-for="(orgaoApoiado, index) in listaOrgaosApoiados"
								:key="'orgao-' + index"
								:value="orgaoApoiado.id"
							>
								{{ orgaoApoiado.descricao }}
							</option>
						</select>
					</div>
					<!-- CARGO / FUNÇÂO -->
					<div class="col-xs-12 col-sm-3 col-md-4 col-lg-3 form-group">
						<label
							>{{ _traducao('global', 'cargo') }} /
							{{ _traducao('global', 'funcao') }}:
						</label>
						<div class="input-group">
							<select
								v-model="form.passageiro.id_funcao"
								class="form-control input-sm"
							>
								<option value="">
									{{ _traducao('global', 'escolha').toUpperCase() }}
								</option>
								<option
									v-for="cargo of listaCargos"
									:key="cargo.id"
									:value="cargo.id"
								>
									{{ cargo.descricao }}
								</option>
							</select>
							<span class="input-group-btn">
								<button
									class="btn btn-sm btn-info"
									type="button"
									@click="exibeCadastroCargo()"
								>
									<i class="fa fa-plus"></i>
								</button>
								<modal-cad-cargo ref="modalCadCargo"></modal-cad-cargo>
							</span>
						</div>
					</div>
					<!-- GRUPO DE PASSAGEIROS -->
					<div class="col-xs-12 col-sm-6 col-md-3 col-lg-3 no-print form-group">
						<label v-if="tripulacaoTecnica == '1'"
							>{{ _traducao('global', 'grupoDeTripulantesTecnicos') }}:</label
						>
						<label v-else
							>{{ _traducao('global', 'grupoDePassageiros') }}:</label
						>
						<div class="input-group">
							<select class="form-control input-sm" v-model="grupoPassageiro">
								<option value="">
									{{ _traducao('global', 'escolha').toUpperCase() }}
								</option>
								<option
									v-for="(item, indexGrupo) in listaGruposPassageiros"
									:value="item"
									:key="`grupo-${item.descricao}-${indexGrupo}`"
								>
									{{ item.descricao }}
								</option>
							</select>
							<span class="input-group-btn">
								<button
									class="btn btn-sm btn-info"
									type="button"
									@click="clickAddGrupo"
								>
									ADD<i class="fa fa-arrow-right fa-fw"></i>
								</button>
							</span>
						</div>
						<div class="row">
							<div
								class="col-xs-12 col-sm-6 col-md-9 col-lg-9"
								:class="{'form-group': _isMobile}"
							>
								<label style="margin-bottom: 6px">&nbsp;</label>
								<br />
								<span
									v-for="grupo in gruposNaoExcluido"
									:key="'grupo-' + grupo.id_grupo"
									style="margin-top: 3px"
								>
									<span
										title="Clique para remover"
										@click="clickExcluirGrupo(grupo)"
										class="label-click"
									>
										{{ grupo.descricao }}
										<i class="fa fa-times no-print"></i>
									</span>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<flCabecalhoForm
						:texto="_traducao('global', 'enderecoResidencial')"
					/>
					<!-- CEP -->
					<div class="col-xs-6 col-sm-4 col-md-4 col-lg-3 form-group">
						<label>{{ _traducao('global', 'cep') }}:</label>
						<input
							v-model="form.passageiro.cep"
							class="form-control input-sm"
							v-mask="_vcep"
							:disabled="form.passageiro.bloquear && flagCompleto()"
						/>
					</div>
					<!-- LOGRADOURO -->
					<div class="col-xs-9 col-sm-6 col-md-4 col-lg-2 form-group">
						<label>{{ _traducao('global', 'logradouro') }}:</label>
						<input
							v-model="form.passageiro.logradouro"
							class="form-control input-sm"
							:disabled="form.passageiro.bloquear && flagCompleto()"
						/>
					</div>
					<!-- NÚMERO -->
					<div class="col-xs-3 col-sm-4 col-md-4 col-lg-1 form-group">
						<label>{{ _traducao('global', 'numero') }}:</label>
						<input
							v-model="form.passageiro.numero"
							class="form-control input-sm"
							:disabled="form.passageiro.bloquear && flagCompleto()"
						/>
					</div>
					<!-- COMPLEMENTO -->
					<div class="col-xs-9 col-sm-8 col-md-4 col-lg-2 form-group">
						<label
							>{{ _traducao('menuAGnovoUsuario', 'menuAGcomplemento') }}:</label
						>
						<input
							v-model="form.passageiro.complemento"
							class="form-control input-sm"
							:disabled="form.passageiro.bloquear"
						/>
					</div>
					<!-- BAIRRO -->
					<div class="col-xs-12 col-sm-4 col-md-4 col-lg-3 form-group">
						<label>{{ _traducao('global', 'bairro') }}:</label>
						<input
							v-model="form.passageiro.bairro"
							class="form-control input-sm"
							:disabled="form.passageiro.bloquear && flagCompleto()"
						/>
					</div>
					<!-- CIDADE -->
					<div class="col-xs-6 col-sm-5 col-md-4 col-lg-3 form-group">
						<label>{{ _traducao('global', 'cidade') }}:</label>
						<input
							v-model="form.passageiro.cidade"
							class="form-control input-sm"
							:disabled="form.passageiro.bloquear && flagCompleto()"
						/>
					</div>
					<!-- UF -->
					<div class="col-xs-3 col-sm-3 col-md-4 col-lg-1 form-group">
						<label>UF:</label>
						<input
							v-model="form.passageiro.estado"
							class="form-control input-sm"
							:disabled="form.passageiro.bloquear && flagCompleto()"
						/>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<flCabecalhoForm
						:texto="_traducao('global', 'contatoDeEmergencia')"
					/>
					<!-- CONTATO EM CASO DE EMERGÊNCIA -->
					<div class="col-xs-12 col-sm-5 col-md-4 col-lg-3 form-group">
						<label
							>{{ _traducao('global', 'contatoEmCasoDeEmergencia') }}:</label
						>
						<input
							v-model="form.passageiro.nome_emergencia"
							class="form-control input-sm"
							:disabled="form.passageiro.bloquear && flagCompleto()"
						/>
					</div>
					<!-- GRAU DE PARENTESCO -->
					<div class="col-xs-12 col-sm-3 col-md-4 col-lg-3 form-group">
						<label>{{ _traducao('menuAGcadAluno', 'grauParentesco') }}:</label>
						<input
							v-model="form.passageiro.relacionamento_emergencia"
							:title="form.task_title"
							class="form-control input-sm"
							:disabled="form.passageiro.bloquear && flagCompleto()"
						/>
					</div>
					<!-- TELEFONE DE EMERGÊNCIA -->
					<div class="col-xs-12 col-sm-4 col-md-4 col-lg-3 form-group">
						<label>{{ _traducao('global', 'telefoneDeEmergencia') }}:</label>
						<input
							v-model="form.passageiro.telefone_emergencia"
							class="form-control input-sm"
							v-mask="_vtelefone"
							:disabled="form.passageiro.bloquear && flagCompleto()"
						/>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-xs-12">
					<flCabecalhoForm
						:texto="_traducao('global', 'informacoesAdicionais')"
					/>
					<!-- NÚMERO SIAPE -->
					<div class="col-xs-12 col-sm-4 col-md-4 col-lg-2 form-group">
						<label>{{ _traducao('global', 'numSiape') }}: </label>
						<input
							v-model="form.passageiro.siape"
							class="form-control input-sm"
						/>
					</div>
					<!-- LOTAÇÃO -->
					<div class="col-xs-12 col-sm-4 col-md-4 col-lg-2 form-group">
						<label>{{ _traducao('global', 'lotacao') }}: </label>
						<div class="input-group">
							<select
								class="form-control input-sm"
								v-model="form.passageiro.id_lotacao"
							>
								<option value="">
									{{ _traducao('global', 'escolha').toUpperCase() }}
								</option>
								<option
									v-for="lotacao in listaLotacao"
									:key="lotacao.id"
									:value="lotacao.id"
								>
									{{ lotacao.descricao }}
								</option>
							</select>
							<span class="input-group-btn">
								<button
									class="btn btn-sm btn-info"
									type="button"
									@click="exibeCadastroLotacao()"
								>
									<i class="fa fa-plus"></i>
								</button>
								<modal-cad-lotacao ref="modalCadLotacao"></modal-cad-lotacao>
							</span>
						</div>
					</div>
					<!-- Equipe Titular-->
					<div class="col-xs-12 col-sm-4 col-md-4 col-lg-2 form-group"></div>
				</div>
			</div>
			<div
				class="col-xs-12 col-md-3 form-group"
				v-if="usuario_aeromedico == true"
			>
				<label>
					<span class="no-print">* </span
					>{{ _traducao('menuAGnovoUsuario', 'menuAGcargo') }}:
				</label>
				<select
					class="form-control input-sm"
					v-model="form.passageiro.id_cargo"
					@change="getSiglaConselho(form.passageiro.id_cargo)"
				>
					<option value="">
						{{ _traducao('global', 'escolha').toUpperCase() }}
					</option>
					<option
						v-for="(item, idx) in listaCargosRegional"
						:value="item.id"
						:key="idx"
					>
						{{ item.descricao }}
					</option>
				</select>
			</div>
			<div
				class="col-xs-12 col-md-3 form-group"
				v-if="usuario_aeromedico == true"
			>
				<label> {{ _traducao('global', 'conselhoRegional') }} </label>
				<input
					class="form-control input-sm"
					v-model="form.passageiro.sigla_conselho"
					type="text"
					disabled
				/>
			</div>
			<!--  ESTADO -->
			<div
				class="col-xs-12 col-md-1 form-group"
				v-if="usuario_aeromedico == true"
			>
				<label><span class="no-print"></span>UF</label>
				<i
					class="fa fa-fw fa-info-circle"
					v-tooltip="'Estado de registro no conselho regional'"
				>
				</i>
				<flSelectEstado
					:optionvalue="optionvalue"
					:value="form.passageiro.estado_conselho"
					@v-model="(val) => (form.passageiro.estado_conselho = val)"
					style="width: 108%"
				/>
			</div>
			<div class="col-xs-3 form-group" v-if="usuario_aeromedico == true">
				<label>{{ _traducao('global', 'numeroRegistro') }}</label>
				<input
					class="form-control input-sm"
					v-model="form.passageiro.num_registro_profissional"
					type="text"
				/>
			</div>
			<!-- botao salvar -->
			<div class="row">
				<div class="col-xs-6">
					<span class="label label-info pull-left no-print">
						<i class="fa fa-info-circle"></i>
						{{ _traducao('global', 'obrigatorio') }}
					</span>
				</div>
				<div class="col-xs-6">
					<button
						type="button"
						@click="clickSalvar"
						class="btn btn-success pull-right"
					>
						<i class="fa fa-check" aria-hidden="true"></i>
						{{ _traducao('global', 'salvar').toUpperCase() }}
					</button>
				</div>
			</div>
			<modal ref="infoDuplicidade">
				<button
					type="button"
					class="close"
					@click="$refs.infoDuplicidade.modalHide()"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<div class="row">
					<div class="col-sm-12 col-lg-12">
						<h4 class="modal-title">
							{{ _traducao('global', 'observacoes') }}
						</h4>
						<hr />
						<h2 class="text-center text-success">
							{{ _traducao('global', 'documentosSemDuplicidade') }}
						</h2>
						<button
							class="btn btn-success pull-right"
							type="button"
							style="margin-top: 2%"
							@click="confirmaInfo"
						>
							<i class="fa fa-check-circle"> </i>
							{{ _traducao('global', 'estouCiente') }}
						</button>
					</div>
				</div>
			</modal>
			<!-- MODAL SOLICITACAO OK -->
			<modal ref="modalOk">
				<button
					type="button"
					class="close"
					@click="
						$refs.modalOk.modalHide()
						voltaLista()
					"
				>
					<span aria-hidden="true">&times;</span>
				</button>
				<h4 class="modal-title">
					{{ _traducao('global', 'passageiro').toUpperCase() }}
				</h4>
				<hr />
				<h2 class="text-center text-success">
					<i class="fa fa-check-circle"></i>
					{{ _traducao('global', 'passageiroSalvoComSucesso').toUpperCase() }}
				</h2>
				<h2 class="text-center">
					<strong>{{ form.passageiro.nome }}</strong>
				</h2>
				<button
					class="btn btn-default"
					type="button"
					@click="
						$refs.modalOk.modalHide()
						voltaLista()
					"
				>
					<i class="icon-left"></i>
					{{ _traducao('menuAGcadAluno', 'voltarParaLista') }}
				</button>
			</modal>
		</div>
		<div v-show="loadTripulacaoTecnica" class="text-center"><spinner /></div>
	</div>
</template>

<script>
import $tabela from '@/mixins/tabela.js'
import CadastroLotacao from './cadastro-lotacao/modal-cad-lotacao.vue'
import CadastroCargo from './cadastro-cargo/modal-cad-cargo.vue'

export default {
	name: 'CadastroDePassageirosAdmGeral',

	components: {
		'modal-cad-lotacao': CadastroLotacao,
		'modal-cad-cargo': CadastroCargo
	},

	props: {
		id: {
			default: 0
		},
		isNotModal: {
			default: true
		}
	},

	mixins: [$tabela],

	data() {
		return {
			centrodeCusto: '',
			//tabela
			load: false,
			exibirForm: false,
			exibeCadastroPassageiro: false,
			listaOrgaosApoiados: [],
			listaGruposPassageiros: [],
			listaAtencaoEspecial: [],
			grupoPassageiro: null,
			atencaoEspecial: null,
			documentoObrigatorio: '',
			documentoObrigatorioNacional: '',
			documentoObrigatorioInternacional: '',
			listaLotacao: [],
			listaCargos: [],
			listaCargosRegional: [],
			usuario_aeromedico: '',

			flagSolicitante: false,
			usuario: {},
			flagComponente: $cliente.get('componente_passageiro_solicitacao'),

			exibeOutro: false,
			nomeOutroDocumento: 'Outro',
			tripulacaoTecnica: false,
			loadTripulacaoTecnica: false,

			tipoPassageiro: false,
			form: {
				id_usuario: 1,
				passageiro: {
					id: 0,
					nome: '',
					data_nascimento: '',
					telefone: '',
					celular: '',
					cpf: null,
					email: '',
					cep: '',
					logradouro: '',
					numero: '',
					bairro: '',
					complemento: '',
					cidade: '',
					estado: '',
					peso: '',
					pesoMedio: '',
					nome_emergencia: '',
					relacionamento_emergencia: '',
					telefone_emergencia: '',
					celular_emergencia: '',
					id_pessoa: 0,
					cpf: '',
					estrangeiro: false,
					passaporte: '',
					rg: '',
					matricula: '',
					id_funcao: '',
					atencao_especial: [],
					detento: 0,
					id_orgao_apoiado: '',
					grupos: [],
					outro: '',
					siape: '',
					id_lotacao: '',
					nacionalidade: '',
					sexo: '',
					id_cargo: '',
					sigla_conselho: '',
					estado_conselho: '',
					num_registro_profissional: '',
					numero_cadastro_imetame: null,
					tipo_passageiro: 1,
				}
			},

			erro: {
				nome: '',
				cpf: '',
				passaporte: '',
				peso: '',
				telefone: '',
				matricula: '',
				rg: '',
				outro: '',
				sexo: ''
			}
		}
	},

	async mounted() {
		await this.carregaCargosRegional()
		await this.getPassageiro()
		await this.getListaOrgaosApoiados()
		await this.getListaGruposPassageiros()
		await this.getListaAtencaoEspecial()
		await this.carregaObrigatorio()
		await this.carregaLotacao()
		await this.carregaCargosFuncao()
		this.verificaUsuarioAeroMedico()
		this.form.id_usuario = Number(window.$sessao.getId())
	},

	computed: {
		gruposNaoExcluido() {
			if (!Array.isArray(this.form.passageiro.grupos)) {
				return null
			}
			return this.form.passageiro.grupos.filter((grupo) => !grupo.excluir)
		},
		usuarioSolicitante() {
			return this.usuario.solicitante && this.flagSolicitante
		},
		atencaoNaoExcluido() {
			if (!Array.isArray(this.form.passageiro.atencao_especial)) {
				return null
			}
			return this.form.passageiro.atencao_especial.filter((att) => !att.excluir)
		},
		optionvalue() {
			if ($cliente.get('id') == 4) {
				return 'NOME'
			}
			return 'SIGLAS'
		}
	},

	watch: {
		'form.passageiro.sexo'(newVal) {
			switch (newVal) {
				case 'c':
					this.form.passageiro.pesoMedio = 30
					break
				case 'f':
					this.form.passageiro.pesoMedio = 70
					break
				case 'm':
					this.form.passageiro.pesoMedio = 80
					break
				default:
					this.form.passageiro.pesoMedio = 0
			}
		},
	},

	async created() {
		await this.parametros()
	},

	methods: {
		limpar() {
			this.form.passageiro = {
				id: 0,
				nome: '',
				data_nascimento: '',
				telefone: '',
				celular: '',
				cpf: null,
				email: '',
				cep: '',
				logradouro: '',
				numero: '',
				bairro: '',
				complemento: '',
				cidade: '',
				estado: '',
				outro: '', 
				peso: '',
				nome_emergencia: '',
				relacionamento_emergencia: '',
				telefone_emergencia: '',
				celular_emergencia: '',
				id_pessoa: 0,
				cpf: '',
				estrangeiro: false,
				passaporte: '',
				rg: '',
				matricula: '',
				id_funcao: '',
				atencao_especial: [],
				detento: 0,
				id_orgao_apoiado: '',
				grupos: [],
				outro: '',
				siape: '',
				id_lotacao: '',
				nacionalidade: '',
				tipo_passageiro: 1,
			}
		},

		getTripulacaoTecnica() {
			return new Promise((resolve) => {
				this._getParametro(145).then((valor) => resolve(valor))
			})
		},
		async parametros() {
			this.loadTripulacaoTecnica = true
			this._getParametro(52).then((valor) => (this.centrodeCusto = valor))
			this._getParametro(41).then(
				(valor) => (this.flagSolicitante = Number(valor) == 1)
			)
			this.tripulacaoTecnica = await this.getTripulacaoTecnica()
			this.loadTripulacaoTecnica = false
			this._getParametro(179).then(
				(valor) => (this.tipoPassageiro = Number(valor) == 1)
			)
		},

		async validarCPF() {
			if (this.form.passageiro.cpf) {
				this._httpGet(
					'/Usuario/validador_de_cpf/' + this.form.passageiro.cpf,
					(retorno) => {
						if (!retorno._status) {
							this.erro.cpf = this._traducao('global', 'cpfInvalido')
						} else {
							this.erro.cpf = ''
						}
					}
				)
				const pessoa = await new Promise((resolve) =>
					this._axios(
						'/Usuario/verifica_existente/' + this.form.passageiro.cpf,
						'POST',
						{
							callback(result) {
								if (result) {
									resolve(result)
								}
							}
						}
					)
				)
				if (pessoa.cpf) {
					const {
						id,
						nome,
						data_nascimento,
						telefone,
						celular,
						email,
						cep,
						logradouro,
						numero,
						bairro,
						complemento,
						cidade,
						estado,
						peso,
						nome_emergencia,
						relacionamento_emergencia,
						telefone_emergencia,
						celular_emergencia,
						cpf,
						estrangeiro,
						passaporte,
						rg,
						matricula,
						id_funcao,
						detento,
						id_orgao_apoiado,
						outro,
						siape,
						id_lotacao,
						nacionalidade,
						tipo_passageiro
					} = pessoa.cpf
					this.form.passageiro.id_pessoa = id
					this.form.passageiro.nome = nome
					this.form.passageiro.data_nascimento = data_nascimento
					this.form.passageiro.telefone = telefone
					this.form.passageiro.celular = celular
					this.form.passageiro.email = email
					this.form.passageiro.cep = cep
					this.form.passageiro.logradouro = logradouro
					this.form.passageiro.numero = numero
					this.form.passageiro.bairro = bairro
					this.form.passageiro.complemento = complemento
					this.form.passageiro.cidade = cidade
					this.form.passageiro.estado = estado
					this.form.passageiro.peso = peso
					this.form.tipo_passageiro = tipo_passageiro
					this.form.passageiro.nome_emergencia = nome_emergencia
					this.form.passageiro.relacionamento_emergencia =
						relacionamento_emergencia
					this.form.passageiro.telefone_emergencia = telefone_emergencia
					this.form.passageiro.celular_emergencia = celular_emergencia
					this.form.passageiro.cpf = cpf
					this.form.passageiro.estrangeiro = estrangeiro
					this.form.passageiro.passaporte = passaporte
					this.form.passageiro.rg = rg
					this.form.passageiro.matricula = matricula
					this.form.passageiro.id_funcao = id_funcao
					this.form.passageiro.detento = detento
					this.form.passageiro.id_orgao_apoiado = id_orgao_apoiado
					this.form.passageiro.outro = outro
					this.form.passageiro.siape = siape
					this.form.passageiro.id_lotacao = id_lotacao
					this.form.passageiro.nacionalidade = nacionalidade
					this.form.passageiro.bloquear = true

					const {
						estado_conselho,
						id_cargo,
						num_registro_profissional,
						sigla_conselho
					} = pessoa.usuario_cargo

					this.form.passageiro.id_cargo = id_cargo
					this.form.passageiro.sigla_conselho = sigla_conselho
					this.form.passageiro.estado_conselho = estado_conselho
					this.form.passageiro.num_registro_profissional =
						num_registro_profissional
				}
			} else {
				this.erro.cpf = ''
			}
		},

		verificaUsuarioAeroMedico() {
			this._getParametro(123).then((valor) => (this.usuario_aeromedico = valor))
		},

		carregaObrigatorio() {
			this._getParametro(1).then((valor) => {
				this.documentoObrigatorioNacional = valor
				if (!this.form.passageiro.estrangeiro) {
					this.documentoObrigatorio = valor
				}
			})
			this._getParametro(2).then((valor) => {
				this.documentoObrigatorioInternacional = valor
				if (this.form.passageiro.estrangeiro) {
					this.documentoObrigatorio = valor
				}
			})
			this._getParametro(3).then((valor) => {
				if (Number(valor)) {
					this.exibeOutro = Number(valor)
					this._getParametro(4).then((val) => {
						if (typeof val === 'string') {
							this.nomeOutroDocumento = val.capitalizeFirst()
						}
					})
				}
			})
		},

		verificaObrigatorio() {
			this.form.passageiro.estrangeiro == true
				? (this.documentoObrigatorio = this.documentoObrigatorioInternacional)
				: (this.documentoObrigatorio = this.documentoObrigatorioNacional)
		},

		clickExcluirGrupo(grupoSelecionado) {
			this.form.passageiro.grupos.find((grupo) => {
				if (grupo.id_grupo === grupoSelecionado.id_grupo) {
					grupo.excluir = true
					return true
				}
			})

			this.$set(this.form.passageiro, 'grupos', [
				...this.form.passageiro.grupos
			])
		},

		clickExcluirAtencao(attSelecionado) {
			this.form.passageiro.atencao_especial.find((att) => {
				if (att.id === attSelecionado.id) {
					att.excluir = true
					return true
				}
			})

			this.$set(this.form.passageiro, 'atencao_especial', [
				...this.form.passageiro.atencao_especial
			])
		},

		clickAddGrupo() {
			if (this.grupoPassageiro !== '') {
				let jaAdd = false
				let atualizarExcluido = false

				this.form.passageiro.grupos.find((grupo) => {
					if (grupo.id_grupo === this.grupoPassageiro.id_grupo) {
						if (grupo.excluir) {
							grupo.excluir = false
							atualizarExcluido = true
							jaAdd = true
						} else {
							window.bus.$emit('exibir-notificacao', {
								text: this._traducao('global', 'voceJaAddEssePerfil'),
								type: 'danger'
							})
							jaAdd = true
						}
						return
					}
				})

				if (!jaAdd && this.grupoPassageiro) {
					this.form.passageiro.grupos.push(this.grupoPassageiro)
				} else if (atualizarExcluido) {
					this.$set(this.form.passageiro, 'grupos', [
						...this.form.passageiro.grupos
					])
				}
			}
		},

		clickAddAtencao() {
			if (this.atencaoEspecial !== '') {
				let jaAdd = false
				let atualizarExcluido = false

				this.form.passageiro.atencao_especial.find((grupo) => {
					if (grupo.id === this.atencaoEspecial.id) {
						if (grupo.excluir) {
							grupo.excluir = false
							atualizarExcluido = true
							jaAdd = true
						} else {
							window.bus.$emit('exibir-notificacao', {
								text: this._traducao('global', 'voceJaAddEssePerfil'),
								type: 'danger'
							})
							jaAdd = true
						}
						return
					}
				})

				if (!jaAdd && this.atencaoEspecial) {
					this.atencaoEspecial.id_atencao_especial =
						this.atencaoEspecial.id_atencao_especial
					this.form.passageiro.atencao_especial.push(this.atencaoEspecial)
				} else if (atualizarExcluido) {
					this.$set(this.form.passageiro, 'atencao_especial', [
						...this.form.passageiro.atencao_especial
					])
				}
			}
		},

		getPassageiro() {
			if (Number(this.id)) {
				this._httpGet('Passageiro/view/' + this.id, (retorno) => {
					if (retorno._request && retorno._status) {
						this.preencheEditar(retorno)
					}
				})
			}
		},

		exibeCadastroLotacao() {
			this.$nextTick(() => {
				this.$refs.modalCadLotacao.modalShow()
			})
		},

		exibeCadastroCargo() {
			this.$nextTick(() => {
				this.$refs.modalCadCargo.modalShow()
			})
		},

		voltaLista() {
			this.$router.push({name: 'passageiros'})
		},

		getListaAtencaoEspecial() {
			this._httpGet('/Tipo_atencao_especial/lista', (retorno) => {
				if (retorno._request && retorno._status) {
					this.listaAtencaoEspecial = retorno.lista.map((att) => {
						att.excluir = ''
						return att
					})
				}
			})
		},

		getListaOrgaosApoiados() {
			this._httpGet('/Orgao_apoiado/get', (retorno) => {
				if (retorno._request && retorno._status) {
					this.listaOrgaosApoiados = retorno.lista
					this.carregarDadosUsuario()
				}
			})
		},

		preencheEditar(passageiro) {
			this.form.passageiro = {
				...this.form.passageiro,
				...passageiro,
				peso: parseFloat(passageiro.peso, 2),
				data_nascimento: this._SQLDateToDate(
					passageiro.data_nascimento,
					window.$sessao.getDateFormat()
				)
			}
			this.getSiglaConselho(passageiro.id_cargo)
		},

		clickSalvar() {
			if (this.validaForm()) {
				window.bus.$emit('load-in', {
					text: this._traducao('global', 'salvando')
				})

				if (this.form.passageiro.id != 0) {
					const form = {
						...this.form
					}
					form.passageiro.data_nascimento =
						form.passageiro.data_nascimento !== ''
							? this._dateToDateSQL(
									form.passageiro.data_nascimento,
									window.$sessao.getDateFormat()
							  )
							: ''
					this._httpPost('Passageiro/salvar', form, (retorno) => {
						window.bus.$emit('load-out')

						if (retorno._request && retorno._status) {
							if (this.isNotModal) {
								this.$refs.modalOk.modalShow(60)
							} else {
								this.$emit('passageiro-salvo', retorno.data)
							}
						}
					})
				} else {
					this._axios('Passageiro/existe', 'post', {
						data: this.form.passageiro,
						callback: (res) => {
							if (!res.resposta) {
								window.bus.$emit('load-out')

								this.documentoObrigatorio == 'cpf' ||
								this.documentoObrigatorio == 'passaporte'
									? this.confirmaInfo()
									: this.$refs.infoDuplicidade.modalShow(40)
							} else {
								window.bus.$emit('load-out')
								window.bus.$emit('exibir-notificacao', {
									text: this._traducao('global', 'documentoObrigatorioExiste'),
									type: 'danger'
								})
								if (this.documentoObrigatorio == 'cpf')
									this.erro.cpf =
										_traducao('global', 'documento') +
										' ' +
										this._traducao('global', 'jaExiste').toLowerCase()
								else if (this.documentoObrigatorio == 'passaporte')
									this.erro.passaporte =
										_traducao('global', 'documento') +
										' ' +
										this._traducao('global', 'jaExiste').toLowerCase()
								else if (this.documentoObrigatorio == 'rg')
									this.erro.rg =
										_traducao('global', 'documento') +
										' ' +
										this._traducao('global', 'jaExiste').toLowerCase()
								else if (this.documentoObrigatorio == 'matricula')
									this.erro.matricula =
										_traducao('global', 'documento') +
										' ' +
										this._traducao('global', 'jaExiste').toLowerCase()
								else if (this.documentoObrigatorio == 'outro')
									this.erro.outro =
										_traducao('global', 'documento') +
										' ' +
										this._traducao('global', 'jaExiste').toLowerCase()
							}
						}
					})
				}
			} else {
				window.bus.$emit('exibir-notificacao', {
					text: this._traducao('menuEscala', 'menuEvermelho'),
					type: 'danger'
				})
			}
		},

		confirmaInfo() {
			this.$refs.infoDuplicidade.modalHide()
			this._httpPost('Passageiro/salvar', this.form, (retorno) => {
				window.bus.$emit('load-out')

				if (retorno._request && retorno._status) {
					if (this.isNotModal) {
						this.$refs.modalOk.modalShow(60)
					} else {
						this.$emit('passageiro-salvo', retorno.data)
					}
				}
			})
		},

		getListaGruposPassageiros() {
			this._httpGet('/Grupo_passageiro/lista', (retorno) => {
				if (retorno._request && retorno._status) {
					this.listaGruposPassageiros = retorno.lista.map((grupo) => {
						grupo.id_grupo = grupo.id
						grupo.id = 0
						return grupo
					})
				}
			})
		},

		carregaLotacao() {
			window.bus.$on(
				'atualiza-lista-lotacao',
				(lotacoes) => (this.listaLotacao = lotacoes)
			)
		},

		carregaCargosFuncao() {
			this._axios('Funcao/listar', 'get', {
				callback: (resposta) => (this.listaCargos = resposta.lista)
			})
			window.bus.$on(
				'atualiza-lista-cargo',
				(cargos) => (this.listaCargos = cargos)
			)
		},

		async carregaCargosRegional() {
			this._axios('Cargo/get_cargo', 'get', {
				callback: (resposta) => (this.listaCargosRegional = resposta.lista)
			})
		},

		getSiglaConselho(id) {
			const cargo = this.listaCargosRegional.find((item) => item.id == id)
			if (cargo) {
				this.form.passageiro.sigla_conselho = cargo.sigla_conselho
			}
		},

		carregarDadosUsuario() {
			window.bus.$emit('load-in', {
				text: this._traducao('global', 'carregando')
			})
			this._axios(`/Usuario/editar/${$sessao.getId()}`, 'get', {
				callback: (retorno) => {
					this.usuario = {
						...retorno.usuario,
						perfis: retorno.perfis
					}

					this.usuario.solicitante = this.usuario.perfis.some((item) => {
						return item.id == window.$cliente.get('id_perfil_solicitante')
					})

					if (this.usuario.solicitante) {
						const orgao = this.listaOrgaosApoiados.find((item) => {
							return item.id == this.usuario.id_orgao_apoiado
						})

						if (typeof orgao === 'object') {
							this.form.passageiro.id_orgao_apoiado = orgao.id
						}
					}
				},
				finally: () => {
					window.bus.$emit('load-out')
				}
			})
		},

		flagSimples() {
			return this.flagComponente === 'simples'
		},
		flagCompleto() {
			return this.flagComponente === 'completo'
		},

		validaForm() {
			let passou = true
			let obrigatorio = this._traducao('global', 'esteCampoEObrigatorio')
			this.erro.sexo = ''
			this.erro.nome = ''
			this.erro.peso = ''
			this.erro.telefone = ''
			this.erro.cpf = ''
			this.erro.passaporte = ''
			this.erro.rg = ''
			this.erro.matricula = ''
			this.erro.outro = ''

			if (this.documentoObrigatorio == 'cpf') {
				if (this.form.passageiro.cpf === '') {
					this.erro.cpf = obrigatorio
					passou = false
				}
			} else if (this.documentoObrigatorio == 'passaporte') {
				if (this.form.passageiro.passaporte === '') {
					this.erro.passaporte = obrigatorio
					passou = false
				}
			} else if (this.documentoObrigatorio == 'rg') {
				if (this.form.passageiro.rg === '') {
					this.erro.rg = obrigatorio
					passou = false
				}
			} else if (this.documentoObrigatorio == 'matricula') {
				if (this.form.passageiro.matricula === '') {
					this.erro.matricula = obrigatorio
					passou = false
				}
			} else if (this.documentoObrigatorio == 'outro') {
				if (this.form.passageiro.outro === '') {
					this.erro.outro = obrigatorio
					passou = false
				}
			}

			if (this.form.passageiro.nome == '') {
				this.erro.nome = obrigatorio
				passou = false
			}
			if (
				this.form.passageiro.peso == '' &&
				this.form.passageiro.pesoMedio == ''
			) {
				this.erro.peso = obrigatorio
				passou = false
			}
			if (
				this.form.passageiro.sexo == '' ||
				this.form.passageiro.sexo == null
			) {
				this.erro.sexo = obrigatorio
				passou = false
			}
			if (
				this.tipoPassageiro &&
				(this.form.passageiro.tipo_passageiro == '' ||
				this.form.passageiro.tipo_passageiro == null)
			) {
				this.erro.tipo_passageiro = obrigatorio
				passou = false
			}

			return passou
		},

		desabilitarCampoApi() {
			if (this.id != 0 && this.form.passageiro.numero_cadastro_imetame) {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
<style scoped>
.fl-cabecalho {
	margin-bottom: 10px;
}
</style>